import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '../hooks/useTheme'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { Spinner } from 'react-bootstrap'
import logo from "../img/Tinvaz_Logo.png";
import { RutasSideBar } from '../routers/RoutesPermisse'
import { queryClient } from '../libs/queryClient'

export const Sidebar = () => {

  const { isOpenSide, setIsOpenSide, size } = useTheme()
  const navigate = useNavigate()
  const { userData, setUserData } = useAuth()
  const sidebarRef = useRef(null)
  const [openSubmenu, setOpenSubmenu] = useState(null)

  const logOut = () => {
    localStorage.clear()
    // Purgar cache de React Query para evitar que un usuario siguiente vea
    // datos cacheados del usuario actual (mitiga S-MED-01).
    queryClient.clear()
    setUserData(null)
    navigate('/login')
  }

  const handleNavigate = (route) => {
    navigate(route)
    setOpenSubmenu(null)
    if (size.width < 768) {
      setIsOpenSide(false)
    }
  }

  const toggleSubmenu = (name) => {
    if (!isOpenSide) {
      setIsOpenSide(true)
      setOpenSubmenu(name)
      return
    }
    setOpenSubmenu(prev => prev === name ? null : name)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpenSide && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        const hamburgerButton = document.querySelector('.logo')
        if (hamburgerButton && !hamburgerButton.contains(event.target)) {
          setIsOpenSide(false)
          setOpenSubmenu(null)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpenSide, setIsOpenSide])

  useEffect(() => {
    if (!isOpenSide) setOpenSubmenu(null)
  }, [isOpenSide])

  console.log(userData)
  
  return (
    <>
      {/* Overlay para cerrar sidebar en móvil */}
      {isOpenSide && size.width < 768 && (
        <div className="sidebar-overlay" onClick={() => setIsOpenSide(false)} />
      )}
      
      <div className='cuerpo'>
        {userData ? (
          <div 
            ref={sidebarRef}
            className={`sidebars ${isOpenSide ? 'open' : 'closed'}`}
          >
            
            <div className='sidebar_logo'>
              {isOpenSide ? (
                <div className='LogoBG'>
                  <img className="logoSide" src={logo} alt="logo_biolab"></img>
                </div>
              ) : (
                <div className='logo-collapsed'>T</div>
              )}
            </div>

            <ul className="nav_link">
              <li className='icon-link iconos'>
                <Link to='/' onClick={() => size.width < 768 && setIsOpenSide(false)}>
                  <i className="bi bi-grid iconos"></i>
                  <span className='Link_name'>Inicio</span>
                </Link>
              </li>
              
              {RutasSideBar(userData.role.permisos, userData.role?.nombre)?.map(({name, icon, route, subRoute}) => (
                <li key={name} className={`link-content${subRoute && openSubmenu === name ? ' submenu-open' : ''}`} onClick={() => subRoute ? toggleSubmenu(name) : handleNavigate(route)}>
                  <div className="icon-link">
                    <i className={`bi ${icon} iconos`}></i>
                    <span className='Link_name'>{name}</span>
                    {subRoute ? (
                      <div>
                        <i className={`bi bi-chevron-down iconos chevron-toggle${openSubmenu === name ? ' chevron-rotated' : ''}`}></i>
                      </div>
                    ) : null}
                  </div>
                  {subRoute ? (
                    <ul className="sublink">
                      {subRoute.map(({name, route}) => (
                        <li key={name} onClick={(e) => {
                          e.stopPropagation()
                          handleNavigate(route)
                        }}>
                          {name}
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}

              {/* Separador visual */}
              <div className="sidebar-divider"></div>

              {/* Opciones de usuario - siempre visibles en sidebar */}
              <li className='icon-link iconos'>
                <Link to={`/perfil?_id=${userData._id}`} onClick={() => size.width < 768 && setIsOpenSide(false)}>
                  <i className="bi bi-person iconos"></i>
                  <span className='Link_name'>Perfil</span>
                </Link>
              </li>
              
              <li className='icon-link iconos'>
                <a href="#" onClick={(e) => {
                  e.preventDefault()
                  logOut()
                }}>
                  <i className="bi bi-box-arrow-right iconos"></i>
                  <span className='Link_name'>Salir</span>
                </a>
              </li>
            </ul>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </>
  )
}
